import { useFeatureFlag } from '@order/LaunchDarkly';

export const useNewLocationsLayout = () => {
  return useFeatureFlag('CELS-2508-location-selection-updates-enabled');
};
